import eventBus from './eventBus'

export function saveUserInfo(userinfo) {
  sessionStorage.setItem('token', userinfo.token)
  sessionStorage.setItem('isLoggedIn', '1')
  sessionStorage.setItem('userInfo', JSON.stringify(userinfo))
  eventBus.$emit('auth:changed')
}

export function getUserInfo() {
  const raw = sessionStorage.getItem('userInfo')
  return raw ? JSON.parse(raw) : null
}

export function clearUserInfo() {
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('isLoggedIn')
  sessionStorage.removeItem('userInfo')
  eventBus.$emit('auth:changed')
}

export function notifyUnauthorized() {
  sessionStorage.removeItem('token')
  eventBus.$emit('auth:unauthorized')
}
